import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import SearchBar from '../datatable/SearchBar';
import RelationDataTable from '../datatable/RelationDataTable';
import Thumbnail from '../thumbnail/Thumbnail';
import { COLUMN_STYLE, getColumnStyle } from '../datatable/util';

import { defaultRejectHandler, getStatusStyle, stringifyErrorMessage } from '../../utils/utility';
import { searchACCentralByText } from '../../redux/ac_central/ac_central_actions';

import {
  addACCentralToBuilding,
  listACCentralInBuilding,
  removeACCentralFromBuilding,
} from '../../redux/projects/project_ac_central_actions';
import { getProject } from '../../redux/projects/projects_actions';


export class ACCentralDataTable extends React.Component {
  constructor(props) {
    super(props);
    const { t } = props;

    this.search = {
      pageSize: this.DEFAULT_PAGE_SIZE,
      page: null,
      sorted: null,
      filtered: null,
    };

    const textColumn = getColumnStyle(COLUMN_STYLE.text);
    const coeColumn = getColumnStyle(COLUMN_STYLE.coefficient);

    this.columns = [
      {
        Header: '',
        accessor: 'ac_central.thumbnail',
        Cell: row => <Thumbnail img={row.value} />,
        ...getColumnStyle(COLUMN_STYLE.thumbnail),
      },
      {
        Header: () => <b>{t('name')}</b>,
        accessor: 'ac_central.name',
        ...textColumn,
        entity: {
          list: (text, page) => searchACCentralByText(text, page)
            .then(response => response.data.map(({name, id}) => ({label: name, value: String(id)}))),
        },
      },
      {
        id: 'coolingCapacity',
        Header: () => <b>{t('cooling capacity')}</b>,
        accessor: 'ac_central.chiller_cooling_capacity',
        ...coeColumn,
        width: 160,
      },
      {
        Header: () => <b>{t('status')}</b>,
        accessor: 'ac_central.chiller_status',
        Cell: row => <span className={getStatusStyle(row.value)}>{t(String(row.value).toLowerCase())}</span>,
        width: 80,
        ...textColumn,
      },
    ];

    this.state = {};
  }

  updateSortFilter(filter, state, category) {
    if (state) {
      this.search.pageSize = state.pageSize;
      this.search.page = state.page;
      this.search.sorted = state.sorted;
    }
    this.search.filtered = filter;
    this.props.listACCentral(
      this.search.pageSize,
      this.search.page,
      this.search.sorted,
      this.search.filtered,
      {
        all: null,
        public: true,
        private: false,
      }[category],
    );

    this.setState({ categoryOption: category });
  }

  render() {
    const { categoryOption } = this.state;

    const {
      buildingId,
      filtered,
      filteredCount,
      isACCentralLoading,
      addACCentral,
      removeACCentral,
      isACCentralAdding,
      isACCentralRemoving,
      errorMessage,
    } = this.props;

    const relationship = {
      create: ({ entityId }) => addACCentral(buildingId, entityId, 1),
      delete: id => removeACCentral(id, buildingId),
      isCreating: isACCentralAdding,
      isDeleting: isACCentralRemoving,
    };

    return (
      <div style={{ backgroundColor: 'white' }}>
        <SearchBar onSearch={text => this.updateSortFilter(text, null, this.state.categoryOption)} />
        <RelationDataTable
          columns={this.columns}
          data={this.props.relationships}
          errorMessage={stringifyErrorMessage(errorMessage)}
          relationship={relationship}
          relationshipNameAccessor={item => item.ac_central.name}
          onActionDelete={item => this.setState({ isShowDeleteModal: true, selectedItem: item.original })}
          filteredCount={filteredCount}
          isLoading={isACCentralLoading}
          onFetchData={state => this.updateSortFilter(filtered, state, categoryOption)}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  relationships: state.projectACCentral.orderedIds.map(id => state.projectACCentral.objects[id]),
  filteredCount: state.projectACCentral.filteredCount,
  isACCentralAdding: state.projectACCentral.isCreating,
  isACCentralRemoving: state.projectACCentral.isDeleting,
  isACCentralLoading: state.projectACCentral.isLoading,
  errorMessage: state.projectACCentral.errorMessage,
});

const mapDispatchToProps = (dispatch, props) => ({
  listACCentral: (pageSize, page, sorted, filtered, isPublic) =>
    defaultRejectHandler(dispatch(listACCentralInBuilding(pageSize, page, sorted, filtered, isPublic, props.buildingId))),
  addACCentral: (buildingId, acCentralId, quantity) =>
    defaultRejectHandler(dispatch(addACCentralToBuilding(acCentralId, buildingId, quantity))
      .then(() => dispatch(getProject(props.projectId)))),
  removeACCentral: (projectACCentralId, buildingId) =>
    defaultRejectHandler(dispatch(removeACCentralFromBuilding(projectACCentralId, buildingId))
      .then(() => dispatch(getProject(props.projectId)))),
});

export default translate('translations', { withRef: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true },
  )(ACCentralDataTable),
);



// WEBPACK FOOTER //
// ./src/components/project_detail/ACCentralDataTable.js